import React, { useState, useEffect } from 'react';
import { getLayout } from './parking';
import { ActionButtons } from '../App';

// ── 주차 현황 홈화면 템플릿 ──────────────────────────────────
// template: 'parking' 테넌트에서 사용
// 좌 6칸 + 우 6칸 마주보는 구조 (총 12면)
// YOLO 서버에서 번호판 인식 → /api/parking/entry|exit 수신

export default function HomePageParking({ tenant_name, onNavigate, onLogout, authInfo, API_BASE, token, tabs }) {
  const [showProfile, setShowProfile] = useState(false);
  const [showPwForm,  setShowPwForm]  = useState(false);
  const [pwCurrent,   setPwCurrent]   = useState('');
  const [pwNew,       setPwNew]       = useState('');
  const [pwMsg,       setPwMsg]       = useState('');
  const [spots,       setSpots]       = useState([]);
  const [logs,        setLogs]        = useState([]);
  const [loading,     setLoading]     = useState(true);

  const authHeaders = () => ({
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  });

  // 주차 현황 조회
  useEffect(() => {
    fetchStatus();
    fetchLogs();
    const timer = setInterval(fetchStatus, 10000); // 10초마다 갱신
    return () => clearInterval(timer);
  }, []);

  const fetchStatus = async () => {
    try {
      const res  = await fetch(`${API_BASE}/api/parking/status`, { headers: authHeaders() });
      if (!res.ok) { setSpots(DUMMY_SPOTS); return; }
      const data = await res.json();
      if (Array.isArray(data)) setSpots(data);
      else setSpots(DUMMY_SPOTS);
    } catch { setSpots(DUMMY_SPOTS); }
    finally { setLoading(false); }
  };

  const fetchLogs = async () => {
    try {
      const res  = await fetch(`${API_BASE}/api/parking/logs?limit=5`, { headers: authHeaders() });
      if (!res.ok) { setLogs(DUMMY_LOGS); return; }
      const data = await res.json();
      if (Array.isArray(data)) setLogs(data);
      else setLogs(DUMMY_LOGS);
    } catch { setLogs(DUMMY_LOGS); }
  };

  const layout   = getLayout(authInfo?.tenant_id);
  const layoutMeta = layout.meta || { cols: 2, rows: 6 };
  const layoutCells = layout.cells || [];

  // 레이아웃 셀에 실시간 점유 데이터 매핑
  const mergedCells = layoutCells.map(cell => {
    if (cell.type !== 'spot') return cell;
    const live = spots.find(s => s.spot_no === cell.spot_no);
    return { ...cell, ...(live || {}), is_occupied: live?.is_occupied || false };
  });

  const spotCells  = mergedCells.filter(c => c.type === 'spot');
  const occupied   = spotCells.filter(s => s.is_occupied);
  const empty      = spotCells.filter(s => !s.is_occupied);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f0f4f8', fontFamily: '"Pretendard", sans-serif' }}>

      {/* 헤더 */}
      <div style={{ backgroundColor: '#1e3a5f', padding: '20px 20px 16px', boxShadow: '0 2px 8px rgba(0,0,0,0.2)' }}>
        <div style={{ maxWidth: '500px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: '20px', fontWeight: '800', color: '#fff' }}>{tenant_name}</div>
            <div style={{ fontSize: '12px', color: '#93c5fd', marginTop: '2px' }}>🚗 주차 관리 시스템</div>
          </div>
          <div style={{ position: 'relative' }}>
            <div onClick={() => { setShowProfile(!showProfile); setShowPwForm(false); setPwMsg(''); }}
              style={{ width: '36px', height: '36px', borderRadius: '50%', backgroundColor: '#3b82f6',
                       display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
              <span style={{ color: '#fff', fontSize: '14px', fontWeight: 'bold' }}>
                {(authInfo?.username || '?')[0].toUpperCase()}
              </span>
            </div>
            {showProfile && (
              <div style={{ position: 'absolute', right: 0, top: '44px', backgroundColor: '#fff',
                            borderRadius: '14px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                            padding: '12px', zIndex: 100, minWidth: '200px' }}>
                <div style={{ paddingBottom: '10px', borderBottom: '1px solid #f3f4f6', marginBottom: '8px' }}>
                  <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#111827' }}>{authInfo?.username}</div>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '2px' }}>{tenant_name}</div>
                </div>
                <button onClick={() => { setShowPwForm(!showPwForm); setPwMsg(''); setPwCurrent(''); setPwNew(''); }}
                  style={{ width: '100%', padding: '7px 10px', background: 'none', border: 'none',
                           cursor: 'pointer', fontSize: '12px', color: '#3b82f6', textAlign: 'left', borderRadius: '8px' }}>
                  🔑 비밀번호 변경
                </button>
                {showPwForm && (
                  <div style={{ marginTop: '6px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    <input type="password" placeholder="현재 비밀번호" value={pwCurrent}
                      onChange={e => setPwCurrent(e.target.value)}
                      style={{ padding: '8px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '12px', outline: 'none' }} />
                    <input type="password" placeholder="새 비밀번호" value={pwNew}
                      onChange={e => setPwNew(e.target.value)}
                      style={{ padding: '8px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '12px', outline: 'none' }} />
                    {pwMsg && <div style={{ fontSize: '11px', color: pwMsg.startsWith('✅') ? '#16a34a' : '#dc2626' }}>{pwMsg}</div>}
                    <button onClick={async () => {
                      if (!pwCurrent || !pwNew) { setPwMsg('❌ 모두 입력하세요'); return; }
                      try {
                        const res = await fetch(`${API_BASE}/api/auth/change-password`, {
                          method: 'POST',
                          headers: authHeaders(),
                          body: JSON.stringify({ current_password: pwCurrent, new_password: pwNew }),
                        });
                        if (res.ok) { setPwMsg('✅ 변경 완료'); setPwCurrent(''); setPwNew(''); }
                        else { const d = await res.json(); setPwMsg('❌ ' + (d.detail || '변경 실패')); }
                      } catch { setPwMsg('❌ 서버 오류'); }
                    }}
                      style={{ padding: '8px', backgroundColor: '#3b82f6', color: '#fff', border: 'none',
                               borderRadius: '8px', fontSize: '12px', cursor: 'pointer', fontWeight: 'bold' }}>
                      변경
                    </button>
                  </div>
                )}
                <div style={{ borderTop: '1px solid #f3f4f6', marginTop: '8px', paddingTop: '8px' }}>
                  <button onClick={onLogout}
                    style={{ width: '100%', padding: '7px 10px', background: 'none', border: 'none',
                             cursor: 'pointer', fontSize: '12px', color: '#ef4444', fontWeight: 'bold', textAlign: 'left', borderRadius: '8px' }}>
                    🚪 로그아웃
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '500px', margin: '0 auto', padding: '16px' }}>

        {/* 요약 카드 */}
        <div style={{ display: 'flex', gap: '10px', marginBottom: '16px' }}>
          <div style={{ flex: 1, backgroundColor: '#fff', borderRadius: '14px', padding: '16px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)', textAlign: 'center' }}>
            <div style={{ fontSize: '28px', fontWeight: '900', color: '#10b981' }}>{empty.length}</div>
            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>빈 자리</div>
          </div>
          <div style={{ flex: 1, backgroundColor: '#fff', borderRadius: '14px', padding: '16px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)', textAlign: 'center' }}>
            <div style={{ fontSize: '28px', fontWeight: '900', color: '#ef4444' }}>{occupied.length}</div>
            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>주차중</div>
          </div>
          <div style={{ flex: 1, backgroundColor: '#fff', borderRadius: '14px', padding: '16px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)', textAlign: 'center' }}>
            <div style={{ fontSize: '28px', fontWeight: '900', color: '#1e3a5f' }}>{spotCells.length}</div>
            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>전체</div>
          </div>
        </div>

        {/* 주차 지도 */}
        <div style={{ backgroundColor: '#fff', borderRadius: '16px', padding: '16px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: '16px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
            <div style={{ fontWeight: '700', fontSize: '15px', color: '#111827' }}>🗺 주차 지도</div>
            <div style={{ display: 'flex', gap: '10px', fontSize: '11px', color: '#6b7280' }}>
              <span>🟢 빈자리</span>
              <span>🔴 주차중</span>
            </div>
          </div>

          {/* 레이아웃 파일 기반 CSS Grid — 가로 고정, 세로 스크롤 */}
          <div style={{ maxHeight: '28vh', overflowY: 'auto', overflowX: 'hidden' }}>
          {(() => {
            const c = layoutMeta.cols || 2;
            const colTypes = Array.from({ length: c }, (_, ci) => {
              const hasSpot = layoutCells.some(cell => cell.col === ci && cell.type === 'spot');
              return hasSpot ? '80px' : '1fr';
            });
            const templateCols = colTypes.join(' ');
            return (
            <div style={{
              display: 'grid',
              gridTemplateColumns: templateCols,
              gap: '3px',
              width: '100%',
            }}>
            {mergedCells.map((cell, i) => {
              if (cell.type === 'spot') return <SpotCard key={i} spot={cell} />;
              if (cell.type === 'road') return (
                <div key={i} style={{
                  width: '100%', height: '40px',
                  backgroundColor: '#e8e8e8',
                  backgroundImage: 'repeating-linear-gradient(90deg, #e0e0e0 0px, #e0e0e0 2px, transparent 2px, transparent 20px)',
                  borderRadius: '2px',
                }} />
              );
              if (cell.type === 'pillar') return (
                <div key={i} style={{ width: '100%', height: '10px', backgroundColor: '#6b7280', borderRadius: '3px' }} />
              );
              if (cell.type === 'wall') return (
                <div key={i} style={{ backgroundColor: '#d1d5db', borderRadius: '4px', width: '100%', height: '40px', border: '1px solid #9ca3af' }} />
              );
              if (cell.type === 'entrance') return (
                <div key={i} style={{ backgroundColor: '#eef2ff', borderRadius: '4px', border: '1px solid #6366f1',
                                      width: '100%', height: '40px',
                                      display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ fontSize: '9px', fontWeight: '700', color: '#6366f1', letterSpacing: '-0.3px' }}>출입구</span>
                </div>
              );
              return <div key={i} style={{ width: '100%', height: '40px' }} />;
            })}
          </div>
            );
          })()}
          </div>
        </div>

        {/* 최근 입/출차 로그 — 자동 스크롤 */}
        <div style={{ backgroundColor: '#fff', borderRadius: '16px', padding: '12px 16px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: '16px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
            <div style={{ fontWeight: '700', fontSize: '13px', color: '#111827' }}>📋 최근 입/출차</div>
            <button onClick={fetchLogs}
              style={{ fontSize: '10px', color: '#3b82f6', background: 'none', border: 'none', cursor: 'pointer' }}>
              새로고침
            </button>
          </div>
          {logs.length === 0 ? (
            <div style={{ textAlign: 'center', color: '#9ca3af', fontSize: '11px', padding: '8px' }}>기록 없음</div>
          ) : (
            <div
              style={{ height: '60px', overflowY: 'auto', position: 'relative' }}
              onMouseEnter={e => e.currentTarget.querySelector('.scroll-inner').style.animationPlayState = 'paused'}
              onMouseLeave={e => e.currentTarget.querySelector('.scroll-inner').style.animationPlayState = 'running'}
              onTouchStart={e => e.currentTarget.querySelector('.scroll-inner').style.animationPlayState = 'paused'}
              onTouchEnd={e => e.currentTarget.querySelector('.scroll-inner').style.animationPlayState = 'running'}
            >
              <style>{`
                @keyframes scrollUp {
                  0% { transform: translateY(0); }
                  100% { transform: translateY(-50%); }
                }
                .scroll-inner::-webkit-scrollbar { display: none; }
              `}</style>
              <div className="scroll-inner" style={{
                animation: `scrollUp ${logs.length * 2}s linear infinite`,
                display: 'flex', flexDirection: 'column', gap: '4px',
              }}>
                {[...logs, ...logs].map((log, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '3px 0' }}>
                    <span style={{ fontSize: '10px' }}>{log.type === 'entry' ? '🟢' : '🔴'}</span>
                    <span style={{ fontSize: '11px', fontWeight: '700', color: '#111827' }}>{log.plate}</span>
                    <span style={{ fontSize: '10px', color: '#6b7280' }}>{log.spot_no}</span>
                    <span style={{ fontSize: '10px', color: log.type === 'entry' ? '#10b981' : '#ef4444', fontWeight: '600' }}>
                      {log.type === 'entry' ? '입차' : '출차'}
                    </span>
                    <span style={{ fontSize: '10px', color: '#9ca3af', marginLeft: 'auto' }}>{log.time}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* 공통 액션 버튼 */}
        <ActionButtons token={token} tabs={tabs} onNavigate={onNavigate} API_BASE={API_BASE} template='parking' />

      </div>
    </div>
  );
}

// ── 주차면 카드 ───────────────────────────────────────────────
function SpotCard({ spot }) {
  const [showDetail, setShowDetail] = useState(false);

  return (
    <div onClick={() => spot.is_occupied && setShowDetail(!showDetail)}
      style={{ backgroundColor: spot.is_occupied ? '#fef2f2' : '#f0fdf4',
               borderRadius: '8px', padding: '4px',
               border: `2px solid ${spot.is_occupied ? '#fca5a5' : '#86efac'}`,
               width: '100%', height: '40px',
               cursor: spot.is_occupied ? 'pointer' : 'default',
               transition: 'all 0.2s' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontSize: '11px', fontWeight: '700',
                       color: spot.is_occupied ? '#dc2626' : '#16a34a' }}>
          {spot.spot_no}
        </span>
        <span style={{ fontSize: '16px' }}>{spot.is_occupied ? '🚗' : '　'}</span>
      </div>
      {spot.is_occupied && spot.plate && (
        <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '2px', fontWeight: '600' }}>
          {spot.plate}
        </div>
      )}
      {showDetail && spot.is_occupied && (
        <div style={{ marginTop: '6px', paddingTop: '6px', borderTop: '1px solid #fca5a5',
                      fontSize: '10px', color: '#374151' }}>
          <div>입차: {spot.occupied_since || '-'}</div>
          {spot.user_name && <div>차주: {spot.user_name}</div>}
        </div>
      )}
    </div>
  );
}

// ── 더미 데이터 (API 연동 전 테스트용) ───────────────────────
// 더미 데이터 — /api/parking/status 연동 전 테스트용
// spot_no는 레이아웃 파일의 spot_no와 일치해야 함
const DUMMY_SPOTS = [
  { spot_no: 'A01', is_occupied: true,  plate: '12가 3456', user_name: '홍길동', occupied_since: '09:23' },
  { spot_no: 'A02', is_occupied: false },
  { spot_no: 'A03', is_occupied: true,  plate: '78나 1234', user_name: '김철수', occupied_since: '10:45' },
  { spot_no: 'A04', is_occupied: false },
  { spot_no: 'A05', is_occupied: true,  plate: '56다 9012', user_name: '이영희', occupied_since: '11:02' },
  { spot_no: 'A06', is_occupied: false },
  { spot_no: 'B01', is_occupied: false },
  { spot_no: 'B02', is_occupied: true,  plate: '34라 5678', user_name: '박민수', occupied_since: '08:15' },
  { spot_no: 'B03', is_occupied: false },
  { spot_no: 'B04', is_occupied: true,  plate: '90마 2345', user_name: '최지원', occupied_since: '09:50' },
  { spot_no: 'B05', is_occupied: false },
  { spot_no: 'B06', is_occupied: false },
];

const DUMMY_LOGS = [
  { plate: '12가 3456', spot_no: 'A01', type: 'entry', time: '09:23' },
  { plate: '78나 1234', spot_no: 'A03', type: 'entry', time: '10:45' },
  { plate: '99바 0001', spot_no: 'B03', type: 'exit',  time: '11:00' },
  { plate: '56다 9012', spot_no: 'A05', type: 'entry', time: '11:02' },
  { plate: '34라 5678', spot_no: 'B02', type: 'entry', time: '08:15' },
];
